// extracted by mini-css-extract-plugin
export default {"switch":"ToggleButton_switch__6Kmug","slider":"ToggleButton_slider__nic9a","round":"ToggleButton_round__JADR9"};